export const UPDATE_MODEL_VERSION_REQUEST = "UPDATE_MODEL_VERSION_REQUEST";
export const UPDATE_MODEL_VERSION_SUCCESS = "UPDATE_MODEL_VERSION_SUCCESS";
export const UPDATE_MODEL_VERSION_FAILURE = "UPDATE_MODEL_VERSION_FAILURE";
